import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageLayout from "./common/AuthApp";
import { verifyOtp } from "../../service/auth";
import "../../Home.css";
import { toast } from "react-toastify";

const EmployerOtpVerify = () => {
  const otpRefs = useRef([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [btnloading, setBtnLoading] = useState(false);

  const phone = location.state?.phone;

  useEffect(() => {
    if (location.state?.toastMessage) {
    toast.success(location.state.toastMessage);
    window.history.replaceState({}, document.title);
    }

    otpRefs.current.forEach((input, index) => {
      if (!input) return;

      input.addEventListener("input", () => {
        if (input.value.length === 1 && index < otpRefs.current.length - 1) {
          otpRefs.current[index + 1].focus();
        }
      });

      input.addEventListener("keydown", (e) => {
        if (e.key === "Backspace" && input.value === "" && index > 0) {
          otpRefs.current[index - 1].focus();
        }
      });
    });
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const otp = otpRefs.current.map((input) => input.value).join("");
    if (otp.length !== 4) {
      toast.error("Enter 4-digit OTP");
      return;
    }

    try {
      setBtnLoading(true);
      const result = await verifyOtp(phone, otp);

      if (result.status) {
        // Save token and role in localStorage
        localStorage.setItem("token", result.result.token);
        localStorage.setItem("role", result.result.role);

        toast.success(result.message || "OTP verified successfully!");

        // Redirect to dashboard
        navigate("/employer/dashboard", { state: { toastMessage: result.message } });
      } else {
        toast.error(result.message || "Invalid OTP");
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>Home</li>
                <li>Employer Login</li>
                <li>Verify Login</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="loginFormSection pt-50 pb-50 bg1">
        <div className="site-width">
          <div className="row align-item-center justify-content-center">
            <div className="col-md-6">
              <div className="loginSection">
                <div className="loginForm">
                  <div className="right-sidebar-box">
                    <div className="otpForm">
                      <div className="row">
                        <div className="col-md-12">
                          <form onSubmit={handleSubmit}>
                            <div className="form-group text-center">
                              <h4>Validate OTP</h4>
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/img/icons/mobile-otp.svg`}
                                className="mobileotpico"
                                alt="icon"
                              />
                              <p>
                                Enter the OTP sent to your registered mobile number to verify your account{" "}
                              </p>
                            </div>

                            <div className="otpinputRow">
                              {[0, 1, 2, 3].map((i) => (
                                <input
                                  key={i}
                                  type="tel"
                                  inputMode="numeric"
                                  className="form-control otp-input"
                                  maxLength="1"
                                  autoComplete="off"
                                  required
                                  ref={(el) => (otpRefs.current[i] = el)}
                                />
                              ))}
                            </div>

                            <button
                              type="submit"
                              className="mt-4 w-100 normalbtn"
                              disabled={btnloading}
                            >
                              {btnloading ? (
                                <span>
                                  <i
                                    className="fa fa-spinner fa-spin"
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  Verifing...
                                </span>
                              ) : (
                                "Verify OTP"
                              )}
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default EmployerOtpVerify;
